module.exports = __webpack_public_path__ + "static/media/jungwoo-1.jpeg";